"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnsuredNumber = void 0;
const effect_1 = require("effect");
exports.EnsuredNumber = effect_1.Schema.Union([effect_1.Schema.Number, effect_1.Schema.String]).pipe(effect_1.Schema.decodeTo(effect_1.Schema.Number, effect_1.SchemaTransformation.transformEffect({
    decode: (input, options) => {
        if (typeof input === 'number') {
            return effect_1.Effect.succeed(input);
        }
        const num = parseFloat(input);
        if (isNaN(num)) {
            return effect_1.Effect.fail(new effect_1.SchemaIssue.InvalidValue({ message: 'Not a number' }, input, options));
        }
        return effect_1.Effect.succeed(num);
    },
    encode: (input) => effect_1.Effect.succeed(input),
})));
//# sourceMappingURL=ensured-number.js.map